module.exports = __webpack_public_path__ + "img/dryer-heat.70f31470.svg";